import React, { useEffect, useState, useRef }from "react";
import { Modal, Checkbox } from "antd";
import _ from 'lodash';
import styled from "styled-components";
import ActiveDirectoryGroupTable from "./ActiveDirectoryGroupTable";
import useTableSelectionState from '../../../hooks/useTableSelectionState';

const ActiveDirectoryGroupModal = ({ open, closeDialog, importUsers, setImportUsers, onOk }) => {
  
  const gridRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [selectedGroups, setSelectedGroups] = useTableSelectionState(['samAccountName', 'name'], []);

  const handleOk = () => {
    setLoading(true);
    onOk(selectedGroups);
  }

  const afterClose = () => {
    setLoading(false);
    setImportUsers(true);
    setSelectedGroups([]);
  }
  
  return (
    <Modal
      open={open}
      onCancel={closeDialog}
      onOk={handleOk}
      width="900px"
      height={600}
      styles={{
        footer: {
          position: 'absolute',
          bottom: '25px',
          right: '25px'
        }
      }}
      title={`Add Selected Groups`}
      forceRender={false}
      afterClose={afterClose}
      confirmLoading={loading}
      destroyOnClose={true}
      maskClosable={false}
      getContainer="#container"
      okButtonProps={{disabled: selectedGroups.length === 0}}
    >
      <ActiveDirectoryGroupTable
        size="small"
        onClose={closeDialog}
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
      />
      <CheckboxHolder>
        <Checkbox
          checked={importUsers}
          onChange={e => { setImportUsers(e.target.checked)}}
        >
          Import existing DL users
        </Checkbox>
      </CheckboxHolder>
    </Modal>
  );
};

const CheckboxHolder = styled.div`
  position: absolute;
  bottom: 30px;
  right: 175px;
`;  

export default ActiveDirectoryGroupModal;
